import { Footer } from '../Components/Footer/FooterComponent';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio//NavMobile';
import CancionesComponent from '../Components/CancionesComponent';

export const Canciones = (props) => {

    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <CancionesComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}
